import { Resource } from "../resource/resource.model";

export class PreferenceOption extends Resource {
    code: string;
    value: string;
    tenantId: string;
    order: number;
}
